import { render } from "./PersonaGrid.vue?vue&type=template&id=27079456&scoped=true"
import script from "./PersonaGrid.vue?vue&type=script&lang=js"
export * from "./PersonaGrid.vue?vue&type=script&lang=js"

import "./PersonaGrid.vue?vue&type=style&index=0&id=27079456&lang=css"
import "./PersonaGrid.vue?vue&type=style&index=1&id=27079456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27079456"]])

export default __exports__